export const CREDIT_VALUE_CZK = 1; // 1 kredit = 1 Kč

export const PAY_PER_USE_PRICING = [
  {
    key: 'consultation',
    name: 'Právní orientace',
    priceCZK: 70,
    credits: 70,
    description: 'AI shrnutí relevantních předpisů včetně odkazů.'
  },
  {
    key: 'document-generation',
    name: 'Generování smlouvy',
    priceCZK: 100,
    credits: 100,
    description: 'Dokument generovaný na základě obecných právních modelů. Vyžaduje odbornou kontrolu.'
  },
  {
    key: 'contract-analysis',
    name: 'Analýza smlouvy (do 20 stran)',
    priceCZK: 200,
    credits: 200,
    description: 'AI analýza smluvního textu s upozorněním na typická ustanovení a obecná rizika.'
  }
];

export const SUBSCRIPTION_PLANS = [
  {
    key: 'start',
    name: 'START',
    priceCZK: 499,
    credits: 1_500,
    usageExamples: ['~21 orientačních dotazů', '~15 generovaných smluv', '~7 analýz smluv'],
    description: 'Ideální pro jednotlivce, kteří potřebují orientaci v právu několikrát do měsíce.',
    userLabel: 'Pro 1 uživatele'
  },
  {
    key: 'standard',
    name: 'STANDARD',
    priceCZK: 1_299,
    credits: 4_500,
    usageExamples: ['~64 orientačních dotazů', '~45 generovaných smluv', '~22 analýz smluv'],
    description: 'Pro menší kanceláře nebo podnikatele.',
    userLabel: 'Pro 2 uživatele'
  },
  {
    key: 'pro',
    name: 'PRO',
    tagline: 'Pro firmy a týmy',
    priceLabel: 'Na vyžádání',
    creditsLabel: 'Dle potřeby',
    usageExamples: [
      'Kreditní rámec podle vašich procesů',
      'Počet uživatelů nastavíme dle týmu',
      'VIP podpora a individuální SLA'
    ],
    description: 'Připravíme tarif podle potřeb vaší firmy po konzultaci s naší obchodní ředitelkou.',
    userLabel: 'Pro libovolný tým',
    isCustom: true
  }
];

export const EXTRA_CREDIT_PRICE_CZK = 1; // cena za 1 kredit při dokoupení
export const MIN_CREDIT_PURCHASE = 15; // Stripe minimum checkout amount is 15 Kč
